import styled, { css } from "styled-components/macro";

import {
  plannedColor,
  waitingColor,
  plantLossColor,
  speedColor,
  untaggedColor,
  uncollectedColor,
  producingColor,
  unplannedColor,
} from "../../../../constants/colors";
import { TAG_HIGHLIGHT_ROW_CUBIC_BEZIER } from "components/Dashboard/HubletView/SingleTimeline/TagHighlightTimelineBackdrop";
import { SELECTED_SEGMENT_BORDER_WIDTH } from "constants/constants";

const SHRINK_SEGMENT_CSS = `
  transform: translateY(16px) scaleY(0.2);
`;

export const ProductionSegmentStyles = styled.g<{
  $translateY: number;
  $categoriesToShrink: string[];
}>`
  pointer-events: auto;
  .production-segment {
    cursor: pointer;
    opacity: 1;
  }
  .tag-highlight {
    cursor: pointer;
    transform: ${({ $translateY }) => css`translateY(${$translateY}px)`};
    transition: all 0.3s ${TAG_HIGHLIGHT_ROW_CUBIC_BEZIER};
    &.highlightSegment {
      opacity: 0.75;
      @supports (filter: brightness()) {
        filter: brightness(1.2);
        opacity: 1;
      }
    }
  }
  &:hover {
    .production-segment,
    .tag-highlight {
      opacity: 0.75 !important;
      @supports (filter: brightness()) {
        filter: brightness(1.2);
        opacity: 1 !important;
      }
    }
  }
  .production-segment-separation-space {
    fill: white;
  }
  .production-segment-selected-border {
    &.hidden {
      display: none;
    }
    stroke-width: ${SELECTED_SEGMENT_BORDER_WIDTH}px;
    stroke: black;
    fill: none;
    pointer-events: none;
  }
  .production-segment-waiting {
    fill: ${waitingColor};
  }
  .production-segment-unplanned {
    fill: ${unplannedColor};
  }
  .production-segment-producing {
    ${props =>
      props.$categoriesToShrink.includes("producing") ? SHRINK_SEGMENT_CSS : ""}
    fill: ${producingColor};
  }
  .production-segment-planned {
    ${props =>
      props.$categoriesToShrink.includes("planned") ? SHRINK_SEGMENT_CSS : ""}
    fill: ${plannedColor};
  }
  .production-segment-notScheduled {
    ${props =>
      props.$categoriesToShrink.includes("notScheduled")
        ? SHRINK_SEGMENT_CSS
        : ""}
    fill: ${plantLossColor};
  }
  .production-segment-plantLoss {
    ${props =>
      props.$categoriesToShrink.includes("plantLoss") ? SHRINK_SEGMENT_CSS : ""}
    fill: ${plantLossColor};
  }
  .production-segment-speedLoss {
    fill: ${speedColor};
  }
  .production-segment-untagged,
  .production-segment-unknown {
    fill: ${untaggedColor};
  }
  .production-segment-uncollected {
    ${props =>
      props.$categoriesToShrink.includes("uncollected")
        ? SHRINK_SEGMENT_CSS
        : ""}
    fill: ${uncollectedColor};
  }

  .production-segment-loading {
    fill: none;
    stroke: #aaaaaa;
    stroke-width: 5px;
    stroke-dasharray: 10, 8;
    animation: sdash 10s ease-in-out infinite;
    opacity: 0.5;
  }

  @keyframes sdash {
    0% {
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dashoffset: 36;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .output-ticks-good {
    fill: #000000;
  }
  .output-ticks-bad {
    fill: #f95700;
    stroke-width: 4px;
  }
`;
